export default "__VITE_ASSET__CeQMUc$q__"